import React from "react";
import { useSelector } from "react-redux";
import { isPlayingSelector } from "../../../store/selectors";
import { CountdownTimer } from "../../shared";
import Buttons from "../Buttons";
import styles from "./PlayModeButtons.module.scss";

const PlayModeButtons: React.FC = () => {
  const THREE_DAYS_IN_MS = 60 * 1000;
  const NOW_IN_MS = new Date().getTime();

  const isPlaying = useSelector(isPlayingSelector);

  const dateTimeAfterThreeDays = NOW_IN_MS + THREE_DAYS_IN_MS;

  return (
    <div className={styles.parent}>
      <Buttons />
      {isPlaying && (
        <div className={styles.playMode__timer}>
          <h1 className={styles.playMode__timer__title}>Time remaining</h1>
          <CountdownTimer targetDate={dateTimeAfterThreeDays} />
        </div>
      )}
    </div>
  );
};

export default PlayModeButtons;
